<div class="solid-nav-bar"></div>
<mat-toolbar>
  <span class="logo">
    <a routerLink="/guest/landing">
      <img src="assets/Images/Logo/logo.png" alt="MariHub Logo" />
    </a>
  </span>
  <button
    mat-button
    routerLink="supplier/order-confirmation"
    routerLinkActive="mat-active"
  >
    <mat-icon class="material-icons-outlined">content_paste</mat-icon>
    Order Confirmation
  </button>
</mat-toolbar>
